import { checkUser, validateEmail as validateEmailBase } from "@jog/shared";
import { createContext, useCallback, useContext, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
export const ValidateEmail = createContext({
    emailDomainBlackList: [],
    emailEndingWhiteList: [],
});
export const useEmailValidationCtx = () => useContext(ValidateEmail);
export const useValidateEmail = () => {
    const { emailEndingWhiteList, emailDomainBlackList } = useEmailValidationCtx();
    const validateEmail = useCallback((email) => validateEmailBase(email, emailDomainBlackList, emailEndingWhiteList), [emailDomainBlackList, emailEndingWhiteList]);
    return {
        emailDomainBlackList,
        emailEndingWhiteList,
        validateEmail,
    };
};
export const useReCaptcha = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [recaptchaError, setRecaptchaError] = useState(null);
    const onCheck = async (_email) => {
        const email = _email.toLowerCase();
        const errorMessage = "Captcha validation was not successful";
        try {
            if (!executeRecaptcha) {
                setRecaptchaError(errorMessage);
                throw new Error(errorMessage);
            }
            const captchaToken = await executeRecaptcha("validateEmail").catch((e) => {
                console.error(e);
                setRecaptchaError(errorMessage);
                throw new Error(errorMessage);
            });
            if (!captchaToken) {
                setRecaptchaError(errorMessage);
                throw new Error(errorMessage);
            }
            const { available, message } = await checkUser(email, captchaToken);
            if (message) {
                setRecaptchaError(message);
                throw new Error(message);
            }
            else {
                setRecaptchaError(null);
                return { available, email };
            }
        }
        catch (e) {
            console.error(e);
            setRecaptchaError("Something went wrong, please try again later");
            throw new Error("Something went wrong, please try again later");
        }
    };
    return { onCheck, recaptchaError };
};
